/* eslint-disable */
(function () {
  window._rollbarConfig = {
    accessToken: ENV_CONSTANTS.ROLLBAR_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: ENV_CONSTANTS.ENV,
    },
    telemetryScrubber: function (data) {
      var id = data.id;
      var element = document.getElementById(id);

      if (!element) return;

      return element.hasAttribute('data-secret');
    },
    hostWhiteList: ['ebanx.com'],
    checkIgnore: function(isUncaught, args, payload) {
      const [ message ] = args;

      const messageIgnorePatterns = [
        /(SyntaxError|SecurityError|Syntax error|Erro de sintaxe|Script error)/,
        /(Loading chunk (\d+) failed|NetworkError|A ligação à rede foi cortada|Esgotou-se o tempo limite da solicitação)/,
        /(cross-origin|frame with origin)/,
        /3000ms timeout exceeded/,
        /Can't find variable: __webpack_require__/,
        /EBANX LibJS was not loaded/,
        /Network request failed/,
        /La conexión de red se perdió/,
        /Cannot read property 'setItem' of null/,
        /El software causó la anulación de la conexión/,
        /La conexión a Internet parece estar desactivada/,
        /Se ha agotado el tiempo de espera/,
        /No se pudo recuperar/,
        /Falha ao buscar/,
        /La conexión a internet parece estar desactivada/,
        /Tectonics - missing hash/,
        /There is instalment with "Infinity"/,
        /CI-404 Invalid invoice/,
        /Cannot create payment request/,
        /ChunkLoadError/,
      ];

      return messageIgnorePatterns.some(pattern => pattern.test(message));
    },
  };

  require('rollbar/dist/rollbar.snippet');

})();
